module.exports = __webpack_public_path__ + "img/photo-example.28960dd8.png";